import { useState, useCallback } from "react";

export const useConfirmCloseChat = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const openConfirm = useCallback(() => setIsOpen(true), []);
  const closeConfirm = useCallback(() => setIsOpen(false), []);

  const handleOk = useCallback((onOk?: () => void) => {
    setIsOpen(false);
    setTimeout(() => {
      setIsSubmitting(true);
      if (onOk) onOk();
      setIsSubmitting(false);
    }, 0);
  }, []);

  const handleCancel = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    isSubmitting,
    openConfirm,
    closeConfirm,
    handleOk,
    handleCancel,
  };
};
